export default __webpack_public_path__ + "static/media/330_dummy2016-friseur01-mobile-de.9b17f9d6.png";